<template>
  <div>
    <!-- 日本处理 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" width="780px" center>
      <div class="content">
        <!-- *问题严重程度： -->
        <div class="row">
          <div class="label">
            {{ $t('message.SeveritProblem') }} : <span><el-rate v-model="datas.score_severity"></el-rate></span>
          </div>
          <!-- 严重程度分为1星-5星，星级越高越严重  -->
          <div class="val">
            PS：{{ $t('message.SeveritProblemText') }}
          </div>
        </div>
        <!-- **客户重要程度 -->
        <div class="row">
          <div class="label">
            {{ $t('message.CustomeImportance') }} : <span><el-rate v-model="datas.score_priority"></el-rate></span>
          </div>
          <!-- 重要程度分为1星-5星，星级越高客户越重要 -->
          <div class="val">
            PS： {{ $t('message.CustomeImportanceText') }}
          </div>
        </div>
        <!-- 业务解决问题的情况 -->
        <div class="row">
          <div class="label">
            {{ $t('message.BusinessSituation') }} : <span><el-rate v-model="datas.score_resolution"></el-rate></span>
          </div>
          <div class="val">
            <!-- 业务解决问题的情况分为1星-5星，星级越高解决得越完美 -->
            PS： {{ $t('message.BusinessSituationText') }}
          </div>
        </div>
        <!-- *发现问题-解决问题时长： -->
        <div class="row">
          <div class="label">
            {{ $t('message.problemDiscoveryToResolutionDuration') }} : <span><el-rate
                v-model="datas.score_timeliness"></el-rate></span>
          </div>
          <div class="val">
            <!--PS：时长评分分为1星-5星，星级越高代表时长越短，说明解决得越快 -->
            PS： {{ $t('message.durationRatingDescription') }}
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--提交 -->
        <el-button type="primary" @click="save">
          {{ $t("message.submit") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      datas: {
        score_severity: 0,
        score_priority: 0,
        score_resolution: 0,
        score_timeliness: 0,
      },
    };
  },
  methods: {
    // 保存
    save() {

      this.$api.siteConfiguration.addScoreV4(this.datas).then(res => {
        this.$message.success(res.msg)
        this.dialogVisible = false
        this.$parent.clientListV4()
      })

    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 50px 0px 20px;

  .row {
    margin-bottom: 20px;

    .label {
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
    }


    .val {
      flex: 3;
      color: red;
      border-bottom: 1px solid #ccc;
      padding-bottom: 10px;

      p {
        margin-top: 20px;
      }
    }
  }


}
</style>
